{
  "nl": {
    "onboardingGroups": {
      "edit": {
        "heading": "Heb je via je instelling al toegang tot een licentiegroep?",
        "paragraph": "Zo ja, dan kun je de toegang hier activeren. De code ontvang je van de contactpersoon bij jouw onderwijsinstelling.",
        "skip": "Verder zonder code",
        "autoSubmitting": "Licentie wordt geactiveerd …",
        "joined": {
          "title": "Je bent al lid van een licentiegroep",
          "next": "Verder",
          "description": "Je bent via de activeringscode van de groep „{group}“ van de school „{school}“ toegewezen. Heb je nog een code, dan kun je die hier invoeren."
        }
      }
    }
  }
}
